

export const ChartColors = [
    '#009DA0',
    '#FF8D60',
    '#FF586B',
    '#0CC27E',
    '#1CBCD8',
    '#868e96',
    '#009DA0',
    '#FF8D60',
    '#AAAAAA',
    '#FF586B'
];